<template>

<div id="app">
    <transition>
        <router-view keep-alive></router-view>
    </transition>
</div>

</template>

<script>

export default {
    name: 'top'
}

</script>



// WEBPACK FOOTER //
// top.vue?62b8bd47